import React, { Fragment, useEffect } from 'react'

import { Trash2 as Trash2Icon } from 'react-feather'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Grid, IconButton, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { AutocompleteTypeAndSearch, SwitchController } from 'components'

const NcActionItem = ({
  field,
  componentIndex,
  responseUsers,
  isDisabled,
  onRemove,
}) => {
  const { control, errors, setValue, watch } = useFormContext()

  const componentError = errors?.ncActions?.[componentIndex]
  const name = `ncActions[${componentIndex}]`
  const provenEffectivenessValue = watch(`${name}.provenEffectiveness`)

  useEffect(() => {
    setValue(name, field)
    // eslint-disable-next-line
  }, [name])

  return (
    <Grid container spacing={2}>
      <Controller
        as={<Fragment />}
        name={`${name}.originId`}
        control={control}
      />

      <Grid item xs={12}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <SwitchController
            control={control}
            name={`${name}.provenEffectiveness`}
            disabled={isDisabled}
            labelOption={{
              left: 'Eficácia Não Comprovada',
              right: 'Eficácia Comprovada',
            }}
            option={{
              left: false,
              right: true,
            }}
            dynamicChecked={provenEffectivenessValue}
            staticChecked={true}
          />
          {!isDisabled && (
            <IconButton size="small" onClick={onRemove}>
              <Trash2Icon size={20} />
            </IconButton>
          )}
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Controller
          as={
            <TextField
              label="Ação Corretiva *"
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              error={!!componentError?.correctiveAction}
              helperText={componentError?.correctiveAction?.message}
            />
          }
          control={control}
          name={`${name}.correctiveAction`}
          disabled={isDisabled}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <AutocompleteTypeAndSearch
          textField={{
            label: 'Responsável *',
            variant: 'outlined',
            error: !!componentError?.responsibleId,
            helperText: componentError?.responsibleId?.message,
          }}
          requestToLoadOptions={responseUsers}
          name={`${name}.responsibleId`}
          disabled={isDisabled}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Prazo *"
              helperText={componentError?.deadline?.message}
              error={!!componentError?.deadline}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisabled}
            />
          }
          control={control}
          name={`${name}.deadline`}
          mode="onChange"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Data da Verificação"
              helperText={componentError?.verificationDate?.message}
              error={!!componentError?.verificationDate}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisabled}
            />
          }
          control={control}
          name={`${name}.verificationDate`}
          mode="onChange"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          as={
            <TextField
              label="Ação Imediata"
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              error={!!componentError?.immediateAction}
              helperText={componentError?.immediateAction?.message}
            />
          }
          control={control}
          name={`${name}.immediateAction`}
          disabled={isDisabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          as={
            <TextField
              label="Ação Preventiva"
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              error={!!componentError?.preventiveAction}
              helperText={componentError?.preventiveAction?.message}
            />
          }
          control={control}
          name={`${name}.preventiveAction`}
          disabled={isDisabled}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          as={
            <TextField
              label="Verificação de Eficácia"
              fullWidth
              variant="outlined"
              multiline
              minRows={3}
              error={!!componentError?.effectivenessVerification}
              helperText={componentError?.effectivenessVerification?.message}
            />
          }
          control={control}
          name={`${name}.effectivenessVerification`}
          disabled={isDisabled}
        />
      </Grid>
    </Grid>
  )
}

export default NcActionItem
